import React, { useState } from "react";
import Announcement from "../components/Programs/Announcements";
import Aside from "../modules/SideNav/Aside";

function AnnouncementLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            /> */}
      <Announcement handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default AnnouncementLayout;
